import './App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Sliders from './Components/slider.js';
import Menu from './Components/menu';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';

window.addEventListener("scroll", reveal);
window.addEventListener("scroll", reveal2);


function reveal () {
  var reveals = document.querySelectorAll(".reveal");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 300;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}
function reveal2 () {
  var reveals = document.querySelectorAll(".reveal2");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 300;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active2");
    } else {
      reveals[i].classList.remove("active2");
    }
  }
}

function App() {
  return (
    <div className="container2">
      <div className="container">
        <style>{'body { background-color: #071711;}'}</style>
        <div className='circles'>
          <div className='circle'></div>
          <div className=''>
            <div className='circle2'></div>
          </div>
          <div className=''>
            <div className='circle3'></div>
          </div>
          <div className=''>
            <div className='circle4'></div>
          </div>
          <div className=''>
            <div className='circle5'></div>
          </div>
          <div className=''>
            <div className='circle6'></div>
          </div>
          <div className=''>
            <div className='circle7'></div>
          </div>
          <div className=''>
            <div className='circle8'></div>
          </div>
          <div className=''>
            <div className='circle9'></div>
          </div>
          <div className='circle10'></div>
          
        </div>
        <nav className="top-menu">
          <a className="navbar-logo" href="rectangle"><img alt="logo" src="logo2.png"></img></a>
          <Menu/>
          <ul className="menu-main">
            <li><a href="#features">Features</a></li>
            <li><a href="#roadmap">RoadMap</a></li>
            <li><a href="#business">Business model</a></li>
            <li><a href="#partners">Partners</a></li> 
          </ul>
        </nav>
        <div id="rectangle"></div>
        <h1 className="text1">VALUE CREATION<br/>
        THROUGH <span className="color" >META-NFT</span><br/>
        ECOSYSTEM</h1>
        <h4 className="text2">Be a part of a democratized metaverse economy <br className="br"/>
        Unlock financial opportunities with one-of-a-kind marketplace <br className="br"/>
        model.</h4>
        <a className="a1"  href="https://www.google.ru/">
          <img src="images/a2.webp" alt="a1"/>JOIN DISCORD
          <span className='span1'></span>
        </a>
        <div className='images'>
          <img className="img1" alt="0" src="images/img1.webp"/>
          <div className="imgs" >
            <img className="img2" alt="1" src="images/img2.webp"/>
            <img className="img3" alt="2" src="images/img3.webp"/>
            <img className="img4" alt="3" src="images/img4.webp"/>
            <img className="img5" alt="4" src="images/img5.webp"/>
            <img className="img6" alt="5" src="images/img6.webp"/><p/>
          </div>
        </div>
        <img className="img7" alt="6" src="images/img7.webp"/>
        <img className="img8" alt="7" src="images/Arrow.webp"/>
        <div id='features'>
        <div className='reveal'>
          <h1 className="text3">FEATURES</h1>
        </div>
        <div className='reveal2'>
          <div className="iconblock1">
            <div className="icon">
              <img src="images/icon1.webp" alt="8" />          
            </div>
          <h3>COMMUNITY-<br className="br"/>DRIVEN</h3>
          <p className="p">Instead of the typical <br className="br"/>
          buyer-seller driven <br className="br"/>
          market, Meta-N <br className="br"/>
          allows all stakeholders <br className="br"/>
          to participate across <br className="br"/>
          the value chain in the <br className="br"/>
          metaverse space</p>
          </div>
        </div>
        <div className='reveal'>
          <div className="iconblock2">
            <div className="icon">
              <img src="images/icon2.webp" alt="9" />
            </div>
            <h3>FAIR PRICE <br className="br"/>
            DISCOVERY</h3>
            <p className="p1">A fair and transparent <br className="br"/>
            pricing for NFTs that is <br className="br"/>
            driven by the community <br className="br"/>
            present in the <br className="br"/>
            metaverse space</p>
          </div>
        </div>
        <div className='reveal2'>
          <div className="iconblock3">
            <div className="icon">
              <img src="images/icon3.webp" alt="11" />
      
            </div>
            <h3>LOW <br className="br"/>
            BARRIERS</h3>
            <p className="p1">Built on layer2 solution <br className="br"/>
            which enables low <br className="br"/>
            gas feesand <br className="br"/>
            isenvironmentally <br className="br"/>
            sustainable</p>
          </div>
        </div>
        <div className='reveal'>
          <div className="iconblock4">
            <div className="icon">
              <img src="images/icon4.webp" alt="12" />
      
            </div>
            <h3>ENHANCING <br className="br"/>
            METAVERSE <br className="br"/>
            EXPERIENCE</h3>
            <p className="p2">Creators and bidders <br className="br"/>
            come face to facein the <br className="br"/>
            surreal world for the <br className="br"/>
            value creation</p>
          </div>
        </div>
        <div className='reveal2'>
          <div className="iconblock5">
            <div className="icon">
              <img src="images/icon5.webp" alt="13" />
      
            </div>
            <h3>REVERSE<br className="br"/>
            BIDDING</h3>
            <p className="p1">Metaverse participants <br className="br"/>
            would put the request <br className="br"/>
            for the utilities which <br className="br"/>
            will be driven by <br className="br"/>
            the NFTs</p>
          </div>
        </div>
        </div>
        <div className='icons'>
          <div className='reveal'>
            <h1 className="text4"><span className="color" >META-N</span> VALUE PROPOSITION</h1>
          </div>
          <div className='reveal2'>
            <div className="iconblock6">
              <div className="icon">
                <img src="images/Bidder.webp" alt="14" />          
              </div>
            <h3 className="h3" >BIDDER</h3>
            <p className="ntext">Fair price discovery of the ART determined <br className="br"/>
            collectively by the community. The entire <br className="br"/>
            process is transparent in all aspects <br className="br"/></p>
            </div>
          </div>
          <div className='reveal'>
            <div className="iconblock6">
              <div className="icon1">
                <img src="images/IPFS.webp" alt="15" />          
              </div>
            <h3 className="h31">IPFS</h3>
            <p className="ntext1">Storing digital collectables on-chain <br className="br"/>
            using IPFS (or the InterPlanetary File System)</p>
            </div>
          </div>
          <div className='reveal2'>
            <div className="iconblock6">
              <div className="icon">
                <img src="images/NFTrentals2.webp" alt="16" />          
              </div>
            <h3 className="h3">NFT RENTALS</h3>
            <p className="ntext">Rent digital collectibles in the secondary <br className="br"/>
            marketplace to earn passive income</p>
            </div>
          </div>
          <div className='reveal'>
            <div className="iconblock6">
              <div className="icon1">
                <img src="images/Bragging2.webp" alt="17" />          
              </div>
            <h3 className="h31">BRAGGING RIGHTS</h3>
            <p className="ntext1">Receives the bragging rights for ownership <br className="br"/>
            of NFTs</p>
            </div>
          </div>
          <div className='reveal2'>
            <div className="iconblock6">
              <div className="icon">
                <img src="images/Borrowing.webp" alt="18" />          
              </div>
            <h3 className="h3">BORROWING ON NFTs</h3>
            <p className="ntext">Use NFTs as collateral along with crypto <br className="br"/>
            assets to borrow loans</p>
            </div>
          </div>
          <h1 className="text5" id="business"><span className="color" >ALL-INCLUSIVE</span> BUSINESS MODEL</h1>
          <div className='reveal2'>
            <div className="textblock">
              <h2>Meta-N business model is based on driving value for all stakeholdersby creating <br className="br"/> 
              an incremental NFT-metaverse ecosystem</h2>
            </div>
          </div>
          <div className='reveal2'>
            <div className="business1">
              <div className="icon">
                <img src="images/Creator.webp" alt="19" />          
              </div>
            <h3>CREATOR LISTS ART<br/>
            ON META-N MARKETPLACE<br/>
            AND DEFINES A BIDDING PERIOD</h3>
            </div>
          </div>
          <div className='reveal'>
            <div className="business2">
              <div className="icon">
                <img src="images/Bidders.webp" alt="20" />          
              </div>
            <h3>BIDDERS CAN BID ON THE NFT<br/>
            DURING THE BIDDING PERIOD<br/><br/></h3>
            </div>
          </div>
          <div className='reveal2'>
            <div className="business3">
              <div className="icon">
                <img src="images/Highest.webp" alt="21" />  
                <h3>HIGHEST BIDDER COLLECTS THE NFT</h3>        
              </div>
            </div>
          </div>
          <div className='reveal'>
            <div className="business4">
              <div className="icon">
                <img src="images/Creator2.webp" alt="22" />  
                <h3>CREATOR RECEIVES A FAIR VALUE</h3>        
              </div>
            </div>
          </div>
          <div className='reveal2'>
            <div className="business5">
              <div className="icon">
                <img src="images/NFTcollector2.webp" alt="23" />          
              </div>
              <h3>NFT COLLECTOR WOULD USE THE NFT <br className="br"/>
              IN THE METAVERSE EXPERIENCE <br className="br"/>
              AND DERIVE VALUE FROM IT</h3>
            </div>
          </div>
          <div className='reveal'>
            <div className="business6">
              <div className="icon">
                <img src="images/Creator32.webp" alt="24" />          
              </div>
              <h3>CREATOR GETS A ROYALTY UPTO 4%<br/> 
              EACH TIME THE ART IS RE-SOLD</h3>
            </div>
          </div>
        </div>
        <h1 className='roadmaptext' id='roadmap'>ROADMAP</h1>
        <Sliders className="slider"></Sliders>
        <h1 className='partnerstext' id='partners'>PARTNERS</h1>
        <div className='part_img'>
          <img src="images/part1.webp" alt="part1"/>
          <img src="images/part2.webp" alt="part2"/>
          <img src="images/part3.webp" alt="part3"/>
          <img src="images/part4.webp" alt="part4"/>
          <img src="images/part5.webp" alt="part5"/><br/>
        </div>
        <div className='part_img2'>
          <img src="images/part1.webp" alt="part6"/>
          <img src="images/part2.webp" alt="part7"/>
          <img src="images/part3.webp" alt="part8"/>
          <img src="images/part4.webp" alt="part9"/>
          <img src="images/part5.webp" alt="part10"/>
        </div>
        <div className='futer' id="contacts">
          <div className="btn-group">
              <a className="s" href="https://www.youtube.com/watch?v=CF1Ht5ahhB0">
                <img src="images/tg.webp" alt="25"/>
                <h3>Telegram</h3>
              </a>
              <a className="s1" href="https://www.google.ru/">
                <img src="images/tw.webp" alt="25"/>
                <h3>Twitter</h3>
              </a>
              <a className="s2" href="https://www.google.ru/">
                <img src="images/yt.webp" alt="25"/>
                <h3>Youtube</h3>
              </a>
              <a className="s3" href="https://www.google.ru/">
                <img src="images/inst.webp" alt="25"/>
                <h3>Instagram</h3>
              </a>
              <a className="s4" href="https://www.google.ru/">
                <img src="images/linkedin.webp" alt="25"/>
                <h3>LinkedIn</h3>
              </a>
              <a className="s5" href="https://www.google.ru/">
                <img src="images/ds.webp" alt="25"/>
                <h3>Discord</h3>
              </a>
          </div>
          <h3 className="futt">Meta-N | 2022</h3>
        </div>
      </div>
    </div>
  );
}

export default App;
